import { render, staticRenderFns } from "./uploadBookletCard.vue?vue&type=template&id=4b95b668&"
import script from "./uploadBookletCard.vue?vue&type=script&lang=js&"
export * from "./uploadBookletCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports